import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  template: '<div class="progress-line" aria-hidden="true"><span class="progress-line__bar"></span></div>',
  styleUrl: './loading-spinner.component.scss'
})
export class LoadingSpinnerComponent {
  @Input() fullscreen = true;
}
